/**
 * Hosted DEV environment — swapped in for `environment.ts` via the `development`
 * configuration (build: --configuration development / `npm run build-dev`).
 * Points at the deployed dev API (matches the staging host pattern). For LOCAL
 * development against localhost, use `npm run start-app` (which uses
 * `environment.ts`), not this file.
 */
export const environment = {
  production: false,
  apiBaseUrl: 'https://feedback-api.dev.tech.brafton.com',
  // Dev build embeds the dev-hosted widget bundle.
  widgetBaseUrl: 'https://resources.dev.tech.brafton.com/feedback-widget/',
  // TEMPORARY: Auth0 gates the UI only (popup login). API calls still use the
  // dev wildcard token, fetched after login by core/auth.guard.ts.
  auth0: {
    domain: 'brafton.auth0.com',
    clientId: 'kY1K4mQqFiFsGlkeBObQ3Vc60lHnkMmw',
  },
  // Google OAuth web client (brafton.com Workspace, Internal audience) for the Google
  // exports' "Connect Google" consent popup. Public — the popup returns a one-time
  // code the API exchanges with the client secret. Its Authorized JavaScript
  // origins must include this build's origin.
  google: {
    clientId: '1052352726630-5dtm9ajoukjnmet975bi992t9b90v6hj.apps.googleusercontent.com',
  },
  // NOTE: the auth bridge authorizes the embedding origin per-round against the
  // FeedbackRound's `allowedDomains` (GET /v1/feedbackrounds/{id}/embed-allowed),
  // not a static allowlist. For local testing, add the parent's origin (e.g.
  // http://localhost:3000) to a round's allowedDomains.
};
